import React, { ButtonHTMLAttributes } from "react"
import styled, { css, FlattenSimpleInterpolation } from "styled-components"

import Icon from "~/components/atoms/Icon"
import { Color, LineHeight, SpacingSize, TextSize, Transition } from "~/consts/style-mixins"

type Size = "Medium" | "Small"

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  snsType: keyof typeof SnsType
  size: Size
  disabled?: boolean
  className?: string
}

const SnsButton: React.FC<Props> = ({ children, size, onClick, snsType, ...props }) => {
  return (
    <StyledButton
      {...props}
      styledByType={SnsType[snsType]}
      size={size}
      onClick={
        onClick &&
        ((e) => {
          if (!props.disabled) {
            onClick(e)
          }
        })
      }
    >
      <Icon type="Line" size={24} color={Color.White} className="icon" />
      {children}
    </StyledButton>
  )
}

export default SnsButton

export const SnsType = {
  Line: css`
    background: ${Color.Line};
  `,
}

const ButtonStyle = {
  Padding: {
    Medium: `${SpacingSize.M}px 0 ${SpacingSize.M}px 18px`,
    Small: `11px 0 11px 18px`,
  },
  FontSize: {
    Medium: TextSize.M,
    Small: TextSize.S,
  },
  IconTop: {
    Medium: 12,
    Small: 6,
  },
}

interface StyledProps {
  styledByType: FlattenSimpleInterpolation
  size: Size
}

const StyledButton = styled.button<StyledProps>`
  position: relative;
  display: block;
  font-weight: bold;
  text-align: center;
  color: ${Color.White};
  line-height: ${LineHeight["2XS"]}%;
  ${({ size }) => `
    padding: ${ButtonStyle.Padding[size]};
    font-size: ${ButtonStyle.FontSize[size]}px;
  `}
  text-decoration: none;
  border-radius: 24px;
  width: 100%;
  cursor: pointer;
  ${Transition.Hover};
  ${({ styledByType }) => styledByType};
  .icon {
    position: absolute;
    ${({ size }: StyledProps) => `
      top: ${ButtonStyle.IconTop[size]}px;
      left: 12px;
    `}
  }
`
